<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { clone, isEmpty } from 'lodash'
  import SearchFilter from './SearchFilter'
  import { mapActions, mapState } from 'vuex'
  import AppPagination from '@/components/ui/AppPagination'
  import UserItem from '@/components/modules/user/UserItem'
  import FiltersOverlay from '@/components/overlays/FiltersOverlay'

  export default {
    name: 'OccasionsPage',
    components: {
      UserItem,
      SearchFilter,
      AppPagination,
      FiltersOverlay,
    },
    metaInfo() {
      return {
        title: this.$t('meta.occasions.title'),
      }
    },
    data() {
      return {
        page: 1,
        search: '',
        showFilter: false,
        showFilters: false,
      }
    },
    computed: {
      ...mapState('occasions', [
        'filters',
        'occasions',
        'pagination',
        'filterActive',
        'filterOptions',
      ]),
      showResetSearch() {
        return this.$route.query.query || this.search
      },
      getFiltersCount() {
        return Object.keys(this.filters).length
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1

        if (!isEmpty(value.query) && value.query.trim().length > 0 && !this.filterActive) {
          this.search = value.query.trim()
          this.searchOccasions({ page: this.page, query: this.search })
        } else if (this.filterActive) {
          this.filterOccasions({ page: this.page, query: this.search })
        } else {
          this.getOccasions(this.page)
        }
      },
    },
    created() {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
        if (this.$route.query.query) {
          this.search = this.$route.query.query
          return this.searchOccasions({ page: this.page, query: this.search })
        }
        this.getOccasions(this.page)
      } else if (this.$route.query.query) {
        this.search = this.$route.query.query
        this.searchOccasions({ page: this.page, query: this.search })
      } else {
        this.getOccasions(this.page)
      }
      if (isEmpty(this.filterOptions)) {
        this.getOccasionFilters()
      }
    },
    mounted() {
      this.moveButton()
    },
    beforeDestroy() {
      this.removeButton()
    },
    destroyed() {
      this.clearOccasions()
    },
    methods: {
      ...mapActions('occasions', [
        'resetFilter',
        'getOccasions',
        'updateFilters',
        'clearOccasions',
        'searchOccasions',
        'filterOccasions',
        'setFilterActive',
        'getOccasionFilters',
      ]),
      clearSearch() {
        this.search = ''
        if (this.$route.query.query) {
          this.$router.push({ query: { page: 1 } })
        }
      },
      searchPersons(page = 1) {
        if (!isEmpty(this.search) && this.search.trim().length > 0) {
          this.search = this.search.trim()
          if (
            (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query !== this.search) ||
            this.$route.query.query !== this.search ||
            parseInt(this.$route.query.page) !== parseInt(page)
          ) {
            this.$router.push({ query: { page, query: this.search } })
          } else {
            this.searchOccasions({ page, query: this.search })
          }
        }
      },
      filterPersons(page = 1) {
        this.setFilterActive()
        if (
          (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query) ||
          parseInt(this.$route.query.page) !== parseInt(page)
        ) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          this.filterOccasions({ page, query: this.search })
        }
      },
      updateOccasions(page = 1) {
        this.getOccasions(page)
      },
      onFiltersApplied(filters) {
        this.showFilters = false
        this.updateFilters(clone(filters))
        this.filterPersons()
      },
      onFiltersReset() {
        this.resetFilter()
        this.updateOccasions()
      },
      moveButton() {
        const moveButton = setInterval(() => {
          const filterButton = document.querySelector('.filter-fab')
          if (filterButton) {
            const target = document.querySelector('.v-main')
            clearInterval(moveButton)
            if (target) {
              target.append(filterButton)
              filterButton.classList.remove('invisible')
            }
          }
        }, 200)
      },
      removeButton() {
        const filterButton = document.querySelector('.v-main > .filter-fab')

        if (filterButton) {
          filterButton.remove()
        }
      },
    },
  }
</script>
